import { render } from "./PublishView.vue?vue&type=template&id=31a91626&scoped=true"
import script from "./PublishView.vue?vue&type=script&lang=js"
export * from "./PublishView.vue?vue&type=script&lang=js"

import "./PublishView.vue?vue&type=style&index=0&id=31a91626&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-31a91626"]])

export default __exports__